import { HaccpsState, InitialHaccpState } from '../state/haccp.state';
import {HaccpAction, HaccpActions } from '../actions/haccp.action';

export function HaccpReducers(state = InitialHaccpState, action: HaccpAction): HaccpsState {
    switch (action.type) {
        case HaccpActions.GetTypeProcedureSuccess: {
            return {
                ...state,
                getTypeProcedureSuccess: action.payload,
                getTypeProcedureError: null
            };
        }
        case HaccpActions.GetTypeProcedureError: {
            return {
                ...state,
                getTypeProcedureError: action.payload,
                getTypeProcedureSuccess: null
            };
        }
        case HaccpActions.GetTypeRecordSuccess: {

            return {
                ...state,
                getTypeRecordSuccess: action.payload,
                getTypeProcedureError: null

            };
        }
        case HaccpActions.GetTypeRecordError: {

            return {
                ...state,
                getTypeRecordError: action.payload,
                getTypeRecordSuccess: null
            };
        }
        case HaccpActions.GetHazardTypeSuccess: {

            return {
                ...state,
                getHazardTypeSuccess: action.payload,
                getHazardTypeError: null
            };
        }
        case HaccpActions.GetHazardTypeError: {

            return {
                ...state,
                getHazardTypeError: action.payload,
                getHazardTypeSuccess: null
            };
        }
        case HaccpActions.AddHazardTypeSuccess: {
            return {
                ...state,
                addHazardTypeSuccess: action.payload,
                addHazardTypeError: null
            };
        }
        case HaccpActions.AddHazardTypeError: {
            return {
                ...state,
                addHazardTypeError: action.payload,
                addHazardTypeSuccess: null
            };
        }
        case HaccpActions.CreateHazardSuccess: {
            return {
                ...state,
                createHazardSuccess: action.payload,
                createHazardError: null
            };
        }
        case HaccpActions.CreateHazardError: {
            return {
                ...state,
                createHazardError: action.payload,
                createHazardSuccess: null
            };
        }
        case HaccpActions.GetAllHazardsSuccess: {
            return {
                ...state,
                getAllHazardsSuccess: action.payload,
                getAllHazardsError: null
            };
        }
        case HaccpActions.GetAllHazardsError: {
            return {
                ...state,
                getAllHazardsError: action.payload,
                getAllHazardsSuccess: null
            };
        }
        case HaccpActions.GetHazardByIdSuccess: {
            return {
                ...state,
                getHazardByIdSuccess: action.payload,
                getHazardByIdError: null
            };
        }
        case HaccpActions.GetHazardByIdError: {
            return {
                ...state,
                getHazardByIdError: action.payload,
                getHazardByIdSuccess: null
            };
        }
        case HaccpActions.GetHazardCountSuccess: {
            return {
                ...state,
                getHazardCountSuccess: action.payload,
                getHazardCountError: null

            };
        }
        case HaccpActions.GetHazardCountError: {
            return {
                ...state,
                getHazardCountError: action.payload,
                getHazardCountSuccess: null
            };
        }
        case HaccpActions.HazardSearchSuccess: {
            return {
                ...state,
                hazardSearchSuccess: action.payload,
                hazardSearchError: null

            };
        }
        case HaccpActions.HazardSearchError: {
            return {
                ...state,
                hazardSearchError: action.payload,
                hazardSearchSuccess: null
            };
        }
        case HaccpActions.GetEditHazardSuccess: {
            return {
                ...state,
                getEditHazardSuccess: action.payload,
                getEditHazardError: null
            };
        }
        case HaccpActions.GetEditHazardError: {
            return {
                ...state,
                getEditHazardError: action.payload,
                getEditHazardSuccess: null
            };
        }
        
        default: {
            return state;
        }

    }

}